<style lang="scss" scoped>
@import "./national-identifier.scss";
</style>
<script>

import { mapGetters } from 'vuex'
import ConsumerService from '../../../account/account-consumer.service'
import { CONSTANT } from '../../../../utils/constant'
import sharedService from '../../../../utils/shared-service'

const consumerService = new ConsumerService()

export default {
  name: 'NationalIdentifier',
  data () {
    return {
      nationalIdentifierValue: '',
      validationError: false,
      CONSTANT: CONSTANT,
      nationalIdPreference: false,
      submitted: false
    }
  },
  computed: {
    ...mapGetters(['consumerInfo', 'nationalIdentifier']),

    nationalIdentifierPreference: {
      get () {
        return this.$store.state.configuration.checkout.nationalIdentifierPreference
      },
      set (value) {
        this.$store.commit('updateNationalIdPreference', value)
        sharedService.updateCheckoutButton(false)
      }
    }
  },
  watch: {
    consumerInfo: {
      handler () {
        this.setDefaultValue()
      }
    }
  },
  created () {
    this.setDefaultValue()
  },
  methods: {

    /**
     * This method will set the default value for national id
     */
    setDefaultValue () {
      if (Object.keys(this.consumerInfo).length) {
        this.nationalIdentifierValue = this.consumerInfo.nationalIdentifier
      } else {
        this.nationalIdentifierValue = this.nationalIdentifier
      }
    },

    /**
     * This method will clear the value of national id
     * @returns {Promise<void>}
     */
    async clearNationalIdentifier () {
      this.nationalIdentifierValue = ''
      if (Object.keys(this.consumerInfo).length) {
        this.consumerInfo.nationalIdentifier = ''
      }
      this.$store.commit('changeNationalIdentifier', '')
      await this.$validator.reset()
    },

    /**
     * This method will save the value of national id
     * @param nationalIdentifier
     * @returns {Promise<void>}
     */
    async saveNationalIdentifier (nationalIdentifier) {
      this.submitted = true
      const isValid = await this.$validator.validateAll()
      if (isValid) {
        this.$store.commit('changeNationalIdentifier', nationalIdentifier)
        if (isValid && Object.keys(this.consumerInfo).length !== 0) {
          this.consumerInfo.nationalIdentifier = nationalIdentifier
          consumerService.register(this.consumerInfo).then(res => {
            this.$store.commit('changeConsumerInfo', this.consumerInfo)
          }).catch(error => {
            this.errorMessage = error
            setTimeout(() => {
              this.errorMessage = false
            }, 3000)
          })
        } else if (!isValid) {
          this.$store.commit('changeNationalIdentifier', '')
        }
      }
    }
  }
}
</script>
<template>
  <div
    id="nationalIdentifierSelection"
    class="card mb-4">
    <h5
      aria-controls="nationalIdentifier"
      aria-expanded="true"
      class="card-header collapsed cursor-pointer"
      data-target="#nationalIdentifier"
      data-toggle="collapse"
    >
      <span class="font-weight-bold">{{ $t('label.nationalIdentifier') }}</span>
      <span class="collapsible-arrow pull-right cursor-pointer" />
    </h5>
    <div
      id="nationalIdentifier"
      class="card-body collapse"
    >
      <div class="form-group row">
        <label class="col-sm-4">{{ $t ('label.chooseNationalIdPreference') }}</label>
        <label
          class="toggleSwitch xlarge">
          <input
            v-model="nationalIdentifierPreference"
            type="checkbox">
          <span>
            <span>{{ $t ('label.false') }}</span>
            <span>{{ $t ('label.true') }}</span>
          </span>
          <a/>
        </label>
      </div>
      <div>
        <div
          class="form-group row">
          <label class="col-sm-4">{{ $t('label.nationalIdentifier') }}</label>
          <div class="col-sm-8">
            <input
              v-validate="{ required: true, min: 2, max:20 }"
              id="consumerNationalIdentifier"
              v-model.trim="(nationalIdentifierValue)"
              :class="{ 'is-invalid': submitted && errors.has('nationalIdentifierValue') }"
              class="form-control float-left"
              data-test="nationalIdentifier"
              type="text"
              name="nationalIdentifierValue"
              data-vv-as="National Identifier"
            >
            <div
              v-if="submitted && errors.has('nationalIdentifierValue')"
              class="invalid-feedback">{{ errors.first('nationalIdentifierValue') }}</div>
          </div>
        </div>
        <button
          id="saveBtn"
          class="btn btn-primary btn-lg mt-3"
          @click="saveNationalIdentifier(nationalIdentifierValue)"
        >Save</button>
        <button
          id="clearBtn"
          class="btn btn-white border-primary text-primary btn-lg mt-3 ml-3"
          @click="clearNationalIdentifier()">Clear</button>
      </div>
    </div>
  </div>
</template>
